import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import * as actions from '../../../../redux/action_creators';
import { api_with_method } from '../../../../redux/api_funcs';
import { get_api_url } from '../../../../utils/urls';
import Button from '../../../util_components/button';
import CustomLoading from '../../../util_components/custom_loading';

// PROD-7682: remove hours from a member's current billing cycle. Posts to the apis
// /cms/api/remove_hours endpoint, which validates membership + available balance, deducts the hours
// from the cycle allowance and records an audit entry. Balance guards are enforced server-side and
// any rejection (non-member / not enough hours) surfaces here.
function RemoveHoursForMembership(props) {
  const [hours, setHours] = useState('');
  const [reason, setReason] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showError, setShowError] = useState(false);

  const dispatch = useDispatch();

  const resetError = () => {
    setShowError(false);
    setError('');
  };

  const handleHoursChange = (e) => {
    const { value } = e.target;
    if (value === '' || /^\d*\.?\d*$/.test(value)) {
      setHours(value);
      resetError();
    }
  };

  const handleReasonChange = (e) => {
    setReason(e.target.value);
    resetError();
  };

  const close = () => {
    resetError();
    setHours('');
    setReason('');
    props.closeRemoveHours();
  };

  const handleSubmit = async () => {
    const noOfHours = Number(hours);
    if (!noOfHours || noOfHours <= 0) {
      setShowError(true);
      setError('Please enter a valid number of hours (greater than 0)');
      return;
    }
    if (reason.trim().length < 3) {
      setShowError(true);
      setError('Please enter a reason');
      return;
    }
    const payload = {
      student_uuid: props.studentUUID,
      no_of_hours: noOfHours,
      reason
    };
    const url = get_api_url('remove_hours');
    setLoading(true);
    try {
      await api_with_method('post', url, payload, true);
      close();
      dispatch(actions.set_notification_variable(true, 'success', `${noOfHours} hour(s) removed`));
    } catch (err) {
      setLoading(false);
      setError(
        err?.response?.data?.message || err?.response?.data?.reason || 'Failed to remove hours'
      );
      setShowError(true);
    }
  };

  return (
    <>
      {loading ? (
        <CustomLoading />
      ) : (
        <div>
          <hr className="-mx-6 mb-6 border-gray-200" />
          <div className="flex flex-col gap-4">
            <div>
              <div className="custom-single-select-label">*Hours to remove:</div>
              <input
                type="text"
                inputMode="decimal"
                value={hours}
                onChange={handleHoursChange}
                placeholder="Enter number of hours"
                className="w-full mt-2 px-3 h-10 text-sm border border-borderColor rounded-md focus:outline-none focus:border-mytPrimary"
              />
            </div>
            <div>
              <div className="custom-single-select-label">*Reason:</div>
              <textarea
                value={reason}
                name="reason"
                onChange={handleReasonChange}
                placeholder="Explain why these hours are being removed..."
                className="w-full min-h-[120px] mt-2 px-3 py-2 text-sm border border-borderColor rounded-md resize-y focus:outline-none focus:border-mytPrimary"
              />
            </div>
          </div>
          {showError ? (
            <div className="font-bold text-red-700 mt-4 text-center">{error}</div>
          ) : null}
          <hr className="-mx-6 mt-6 mb-4 border-gray-200" />
          <div className="flex justify-end items-center gap-3">
            <Button type="secondary" onClick={close}>
              Cancel
            </Button>
            <Button onClick={handleSubmit}>Remove Hours</Button>
          </div>
        </div>
      )}
    </>
  );
}

export default RemoveHoursForMembership;
